import { useEffect, useState } from "react";
import { C, ROLE_COLORS } from "../styles/tokens";
import { Logo } from "./ui";
import { ROLES } from "../mock";

const NAV = {
  serveur: [
    { id:"dashboard",    icon:"▦",  label:"Tableau de bord" },
    { id:"tables",       icon:"⬚",  label:"Tables" },
    { id:"orders",       icon:"≡",  label:"Commandes" },
    { id:"invoices",     icon:"◻",  label:"Factures" },
  ],
  cuisinier: [
    { id:"dashboard",    icon:"▦",  label:"Tableau de bord" },
    { id:"kitchen",      icon:"◈",  label:"Cuisine" },
    { id:"stock-request",icon:"◉",  label:"Demande stock" },
    { id:"stats",        icon:"◎",  label:"Mes statistiques" },
  ],
  gérant: [
    { id:"dashboard",    icon:"▦",  label:"Tableau de bord" },
    { id:"tables",       icon:"⬚",  label:"Tables" },
    { id:"orders",       icon:"≡",  label:"Commandes" },
    { id:"menu",         icon:"✦",  label:"Menu & Plats" },
    { id:"invoices",     icon:"◻",  label:"Factures" },
    { id:"stock",        icon:"◉",  label:"Stock" },
    { id:"stock-entries",icon:"⊕",  label:"Gestion achat" },
    { id:"stock-exits",  icon:"◈",  label:"Sorties stock" },
    { id:"reports",      icon:"◎",  label:"Rapports" },
  ],
  gestionnaire: [
    { id:"dashboard",    icon:"▦",  label:"Tableau de bord" },
    { id:"stock",        icon:"◉",  label:"Stock" },
    { id:"demandes",     icon:"📋", label:"Demandes cuisiniers" },
    { id:"stock-entries",icon:"⊕",  label:"Gestion achat" },
    { id:"stock-exits",  icon:"⊖",  label:"Sorties" },
    { id:"stock-history",icon:"≡",  label:"Historique" },
    { id:"depenses",     icon:"💸", label:"Dépenses" },
    { id:"reports",      icon:"◎",  label:"Rapports" },
  ],
  manager: [
    { id:"dashboard",    icon:"▦",  label:"Tableau de bord" },
    { id:"tables",       icon:"⬚",  label:"Tables" },
    { id:"orders",       icon:"≡",  label:"Commandes" },
    { id:"menu",         icon:"✦",  label:"Menu & Plats" },
    { id:"invoices",     icon:"◻",  label:"Factures" },
    { id:"stock",        icon:"◉",  label:"Stock" },
    { id:"stock-entries",icon:"⊕",  label:"Gestion achat" },
    { id:"stock-validate",icon:"✓", label:"Mouvement stock" },
    { id:"stock-exits",  icon:"⊖",  label:"Sorties" },
    { id:"stock-history",icon:"≡",  label:"Historique" },
    { id:"demandes",     icon:"📋", label:"Demandes" },
    { id:"depenses",     icon:"💸", label:"Dépenses" },
    { id:"reports",      icon:"◎",  label:"Rapports" },
    { id:"team",         icon:"◐",  label:"Utilisateurs" },
    { id:"audit",        icon:"◑",  label:"Audit" },
  ],
  auditeur: [
    { id:"dashboard",    icon:"▦",  label:"Tableau de bord" },
    { id:"tables",       icon:"⬚",  label:"Tables" },
    { id:"orders",       icon:"≡",  label:"Commandes" },
    { id:"stock",        icon:"◉",  label:"Stock" },
    { id:"invoices",     icon:"◻",  label:"Factures" },
    { id:"audit",        icon:"◑",  label:"Audit" },
  ],
  admin: [
    { id:"dashboard",    icon:"▦",  label:"Tableau de bord" },
    { id:"tables",       icon:"⬚",  label:"Tables" },
    { id:"kitchen",      icon:"◈",  label:"Cuisine" },
    { id:"orders",       icon:"≡",  label:"Commandes" },
    { id:"menu",         icon:"✦",  label:"Menu & Plats" },
    { id:"stock",        icon:"◉",  label:"Stock" },
    { id:"stock-entries",icon:"⊕",  label:"Gestion achat" },
    { id:"stock-exits",  icon:"⊖",  label:"Sorties" },
    { id:"stock-history",icon:"≡",  label:"Historique" },
    { id:"stock-request",icon:"◉",  label:"Demande stock" },
    { id:"invoices",     icon:"◻",  label:"Factures" },
    { id:"depenses",     icon:"💸", label:"Dépenses" },
    { id:"import",       icon:"⬆", label:"Imports" },
    { id:"reports",      icon:"◎",  label:"Rapports" },
    { id:"team",         icon:"◐",  label:"Utilisateurs" },
    { id:"audit",        icon:"◑",  label:"Audit" },
    { id:"demandes",     icon:"📋", label:"Demandes" },
  ],
};

const Sidebar = ({ role, screen, onNav, user, onLogout, collapsed, setCollapsed, notifCount, mobileOpen, onMobileClose }) => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handler = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener("resize", handler);
    return () => window.removeEventListener("resize", handler);
  }, []);

  const roleKey = (role || "")
    .toLowerCase()
    .replace("gestionnaire de stock", "gestionnaire")
    .split(" ")[0];

  const items = NAV[roleKey] || NAV.admin;

  const handleNav = (id) => {
    onNav(id);
    if (isMobile && onMobileClose) onMobileClose();
  };

  // ── Calcul largeur ──
  const sidebarWidth = isMobile ? 270 : (collapsed ? 66 : 226);

  // ── Styles container ──
  const containerStyle = isMobile
    ? {
        position: "fixed",
        top: 0,
        left: 0,
        height: "100vh",
        width: sidebarWidth,
        background: C.bg1,
        borderRight: `1px solid rgba(255,255,255,0.05)`,
        display: "flex",
        flexDirection: "column",
        zIndex: 1000,
        transform: mobileOpen ? "translateX(0)" : "translateX(-100%)",
        transition: "transform .3s cubic-bezier(.2,.8,.2,1)",
        overflowY: "auto",
        overflowX: "hidden",
      }
    : {
        width: sidebarWidth,
        minHeight: "100vh",
        background: C.bg1,
        borderRight: `1px solid rgba(255,255,255,0.05)`,
        display: "flex",
        flexDirection: "column",
        transition: "width .3s cubic-bezier(.2,.8,.2,1)",
        overflow: "hidden",
        flexShrink: 0,
      };

  return (
    <>
      {/* Overlay mobile */}
      {isMobile && mobileOpen && (
        <div
          onClick={onMobileClose}
          style={{
            position: "fixed", inset: 0, zIndex: 999,
            background: "rgba(0,0,0,0.55)",
            backdropFilter: "blur(2px)",
          }}
        />
      )}

      <div style={containerStyle}>
        {/* Logo area */}
        <div style={{
          padding: isMobile ? "20px 16px" : (collapsed ? "16px 0" : "20px 16px"),
          borderBottom: `1px solid rgba(255,255,255,0.05)`,
          display: "flex", alignItems: "center",
          justifyContent: (!isMobile && collapsed) ? "center" : "flex-start",
          minHeight: 72,
        }}>
          <Logo size={(!isMobile && collapsed) ? 36 : 42} withText={isMobile || !collapsed} />
        </div>

        {/* Collapse toggle — desktop seulement */}
        {!isMobile && (
          <button
            onClick={() => setCollapsed(!collapsed)}
            style={{
              margin: "8px auto 4px",
              background: "rgba(255,255,255,0.04)",
              border: `1px solid rgba(255,255,255,0.07)`,
              color: C.muted, width: 28, height: 28, borderRadius: 6,
              fontSize: 11, display: "flex", alignItems: "center",
              justifyContent: "center", transition: "all .2s",
            }}>
            {collapsed ? "›" : "‹"}
          </button>
        )}

        {/* Nav items */}
        <nav style={{ flex: 1, padding: "4px 8px", overflowY: "auto", overflowX: "hidden" }}>
          {items.map(item => {
            const active = screen === item.id;
            const showLabel = isMobile || !collapsed;
            return (
              <button
                key={item.id}
                onClick={() => handleNav(item.id)}
                title={(!isMobile && collapsed) ? item.label : ""}
                style={{
                  width: "100%", display: "flex", alignItems: "center", gap: 10,
                  padding: showLabel ? "10px 12px" : "10px 0",
                  justifyContent: showLabel ? "flex-start" : "center",
                  borderRadius: 8, border: "none", margin: "2px 0",
                  background: active ? C.goldFaint : "transparent",
                  color: active ? C.goldL : C.muted,
                  borderLeft: active ? `2px solid ${C.gold}` : "2px solid transparent",
                  fontSize: isMobile ? 14 : 13,
                  fontWeight: active ? 600 : 400,
                  fontFamily: "'Raleway',sans-serif",
                  transition: "all .15s",
                  whiteSpace: "nowrap", overflow: "hidden",
                }}>
                <span style={{ fontSize: isMobile ? 16 : 14, flexShrink: 0, opacity: active ? 1 : .7 }}>
                  {item.icon}
                </span>
                {showLabel && <span>{item.label}</span>}
              </button>
            );
          })}
        </nav>

        {/* Notification badge */}
        {(isMobile || !collapsed) && notifCount > 0 && (
          <div style={{
            margin: "0 16px 12px",
            background: `${C.gold}15`,
            border: `1px solid ${C.goldBorder}`,
            borderRadius: 8, padding: "8px 12px",
            display: "flex", alignItems: "center", gap: 8,
          }}>
            <div className="pulse" style={{ width: 8, height: 8, borderRadius: "50%", background: C.gold, flexShrink: 0 }} />
            <span style={{ fontSize: 11, color: C.goldL }}>
              {notifCount} notification{notifCount > 1 ? "s" : ""}
            </span>
          </div>
        )}

        {/* User footer */}
        <div style={{ padding: (!isMobile && collapsed) ? "12px 0" : "12px 14px", borderTop: `1px solid rgba(255,255,255,0.05)` }}>
          <div style={{ display: "flex", alignItems: "center", gap: 10, justifyContent: (!isMobile && collapsed) ? "center" : "flex-start" }}>
            <div style={{
              width: 34, height: 34, borderRadius: 10,
              background: `linear-gradient(135deg,${ROLE_COLORS[roleKey] || C.gold}55,${C.bg4})`,
              border: `1px solid ${ROLE_COLORS[roleKey] || C.gold}40`,
              flexShrink: 0, display: "flex", alignItems: "center",
              justifyContent: "center", fontSize: 12, fontWeight: 700, color: "#fff",
            }}>
              {user.first_name?.[0]}{user.last_name?.[0]}
            </div>
            {(isMobile || !collapsed) && (
              <div style={{ flex: 1, minWidth: 0 }}>
                <div style={{ fontSize: 12, fontWeight: 600, color: C.cream, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                  {user.first_name} {user.last_name}
                </div>
                <div style={{ fontSize: 10, color: C.muted }}>{ROLES[roleKey] || role}</div>
              </div>
            )}
            {(isMobile || !collapsed) && (
              <button
                onClick={onLogout}
                title="Déconnexion"
                style={{ background: "none", border: "none", color: C.muted, fontSize: 16, padding: 3, cursor: "pointer", transition: "color .2s", flexShrink: 0 }}>
                ⏻
              </button>
            )}
          </div>
          {!isMobile && collapsed && (
            <button
              onClick={onLogout}
              style={{ background: "none", border: "none", color: C.muted, fontSize: 14, display: "block", margin: "8px auto 0", cursor: "pointer" }}>
              ⏻
            </button>
          )}
        </div>
      </div>
    </>
  );
};

export default Sidebar;